import { Container, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import type Driver from "@types_def/models/driver.types";

type TDriverQuickDetails = {
  driver: Driver;
};

function getDriverStatusLabel(driver: Driver): string {
  switch (driver.status) {
    case "ACCEPTED":
      return "Accepté";
    case "REJECTED":
      return "Refusé";
    case "DISABLED":
      return "Désactivé";
    case "PENDING":
      return "En attente";
    default:
      return driver.disabled ? "Désactivé" : "Activé";
  }
}

function DriverQuickDetails({ driver }: TDriverQuickDetails) {
  if (!driver) return null;
  const { id, firstName, lastName } = driver;
  return (
    <Container maxWidth="md">
      <Table sx={{ padding: 2, marginTop: 4, border: 1, borderColor: "#ccc" }}>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Nom et Prénom</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{id}</TableCell>
            <TableCell>
              {firstName} {lastName}
            </TableCell>
            <TableCell>{getDriverStatusLabel(driver)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Container>
  );
}

export default DriverQuickDetails;
